import axios from 'axios';

const baseURL = import.meta.env.BACKEND_API_URL;

export default axios.create({
  baseURL,
  responseType: 'json',
});
